import { updateUserInfo } from "@/libs/auth";

const NOT_RESTRICTED_ROUTES = [
    "/test-links",
    "/auth/register",
    "/auth/welcome",
    "/auth/login",
    "/auth/verify-email",
    "/android",
    "/anvandarvillkor-njorda.pdf",
];

// ToDo: refactor with middlewares.
export default defineNuxtPlugin(async () => {
    const router = useRouter();
    const route = useRoute();
    const { defaultRoute, setLoggedIn } = useNjordaApi();

    if (NOT_RESTRICTED_ROUTES.some((path) => route.path.startsWith(path))) {
        return;
    }

    try {
        await updateUserInfo();
        setLoggedIn(true);
    } catch (_e) {
        setLoggedIn(false);
        router.push(defaultRoute);
    }
});
